import { render, staticRenderFns } from "./ShippingDetail.vue?vue&type=template&id=42e6ffcb"
import script from "./ShippingDetail.vue?vue&type=script&lang=ts"
export * from "./ShippingDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports